export const isAbsoluteUrl = (url: string) => {
  const index = url.indexOf('://');
  return index > -1 && index < 6;
};

export const addHttpsToUrl = (url: string) => {
  if (isAbsoluteUrl(url)) {
    return url;
  }
  return 'https://' + url;
};

export interface PreparedUrlParams {
  href: string;
  base?: string;
  searchParams?: {
    [k: string]: string;
  };
}
export function getPreparedUrl({ href, base = '', searchParams = {} }: PreparedUrlParams) {
  if (isAbsoluteUrl(href)) {
    return href;
  }
  const mockHost = 'https://host.mock';
  const url = new URL(href, mockHost);

  Object.keys(searchParams).forEach((key) => {
    url.searchParams.set(key, searchParams[key]);
  });

  return url.toString().replace(mockHost, base);
}

export function getUniqueUrl(url: string, existingUrls: string[]): string {
  let index = 1;
  let uniqueUrl = url;
  let isUnique = false;
  while (!isUnique) {
    if (existingUrls.includes(uniqueUrl)) {
      uniqueUrl = url + `-${index}`;
      isUnique = false;
      index++;
    } else {
      isUnique = true;
    }
  }
  return uniqueUrl;
}

export interface TeamsInviteUrlProps {
  host: string;
  orgId: string;
  workspaceId: string;
  portalId: string;
}

export const getTeamsInviteUrl = ({ host, orgId, workspaceId, portalId }: TeamsInviteUrlProps): string => {
  let url = `https://teams.${host}/org/${orgId}/members/invite?workspace=${workspaceId}`;
  if (portalId) {
    url += `&portal=${portalId}`;
  }
  return url;
};

export const validateURL = (url: string): { valid: boolean; validUrl: string } => {
  const urlPattern =
    /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|\d{1,3}(\.\d{1,3}){3})(:\d+)?(\/[-a-z\d%_.~=+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[a-z\d_]*)?$/i;
  const valid = urlPattern.test(url);

  return {
    valid,
    validUrl: valid && !url.startsWith('https://') ? `https://${url}` : url,
  };
};

export const getParentPath = (urlPath: string): string => {
  const segments = urlPath.replace(/\/$/, '').split('/');
  segments.pop();
  return segments.length > 1 ? segments.join('/') : '/';
};
